import { render, staticRenderFns } from "./battery-switch.vue?vue&type=template&id=c32edd20&scoped=true"
import script from "./battery-switch.vue?vue&type=script&lang=ts"
export * from "./battery-switch.vue?vue&type=script&lang=ts"
import style0 from "./battery-switch.vue?vue&type=style&index=0&id=c32edd20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32edd20",
  null
  
)

export default component.exports